angular.module("componentes").directive("numberField", function () {
	"use strict";

	return {
		scope: true,
		controller: "NumberFieldCtrl",
		controllerAs: "ctrl",
		//transclude: true,
		replace: true,
		templateUrl: "componentes/angular-material/custom/fields/numberField/numberField_template.html",
		bindToController: {
			label: "@",
			name: "@",
			isDisabled: "=",
			isRequired: "=",
			type: "@",
			decimals: "=?",
			hideThousandsSeparator: "@",
			field: "=",
			error: "=",
			mask: "@?",
			min: "@?",
			maxlength: "@?",
			max: "@?",
			onBlur: "&?",
			change: "=?"
		},
		link: function (scope, element, attrs) {
			if (scope && !scope.ctrl.min) {
				scope.ctrl.min = 0;
			}
		}
	};
});
